import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { getAuthHttpHeaders } from "../auth";
import TradesTable from "../trade/TradesTable";
import TradesBarChart from "../trade/TradesBarChart";
import LoadButtonPanel from "../components/LoadButtonPanel";
import TradesDurationChart from "../charts/TradesDurationChart";
import TradeVolumeChart from "../charts/TradeVolumeChart";

@inject("store")
@observer
export default class ClosedTrades extends Component {
  state = {
    loading: false,
    closedTrades: null,
  };

  componentDidMount() {
    this.load();
  }

  async load() {
    const { simId } = this.props;

    this.setState({ loading: true });

    try {
      let axiosRequest = axios.create({
        baseURL: "api",
        timeout: 30 * 1000,
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
      });

      let response = await axiosRequest.get(`sim/${simId}/closedTrades`);
      this.setState({ closedTrades: response.data });
    } catch (e) {
      this.setState({ closedTrades: null });
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const { simId, botConfig, exchangeType } = this.props;
    const tradesData = this.state.closedTrades && this.state.closedTrades.map(ct => JSON.parse(ct.data));

    return (
      <div>
        <TradesTable
          closedTrades={this.state.closedTrades}
          exchangeType={exchangeType}
          botConfig={botConfig}
          trades={tradesData}
          summary
          loading={this.state.loading}
        />
        <LoadButtonPanel
          iconName="chart line"
          loadText="Show Trades by currencies chart"
          createContentCb={() => <TradesBarChart trades={tradesData} loading={this.state.loading} />}
        />
        <LoadButtonPanel
          iconName="chart line"
          loadText="Show Trades duration chart"
          createContentCb={() => (
            <TradesDurationChart trades={this.state.closedTrades} botConfig={botConfig} loading={this.state.loading} />
          )}
        />
        <LoadButtonPanel
          iconName="chart line"
          loadText="Show day volumes of closed trade currencies"
          createContentCb={() => <TradeVolumeChart botId={simId} exchangeType={exchangeType} sim />}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/sim/SimClosedTrades.js